if (document.querySelector('.Booking-offer') !== null) {
    var gift = document.querySelector('.Booking-offer');
    document.addEventListener("DOMContentLoaded", function() {
        gift.addEventListener('click', function() {
            this.classList.toggle('active');
            this.querySelector('input').checked = !this.querySelector('input').checked;
            this.querySelector('.fa-check-square').classList.toggle('hidden');
            this.querySelector('.fa-square').classList.toggle('hidden');
        })
    });
}

if (document.querySelector('#formResa') !== null) {
    // jQuery('#formResa').on('click','#sendForm',function(e){
    jQuery('#form').on('submit',function(e){
        e.preventDefault();
        // console.log(this);
        var lg = jQuery('html').attr("lang");

        //if(loadData === false) {
            loadData = true;
            var url = apidae.base_url + '/services/sendForm';
            var data = jQuery('#form').serialize();
            var action = this.dataset.action;
            var category = this.dataset.category;
            var label = this.dataset.label;


            grecaptcha.ready(function() {
                grecaptcha.execute(apidae.reCaptcha_key, {action: 'form_resa'}).then(function(token) {
                    jQuery('#form').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');

                    jQuery.ajax({
                        type: "POST",
                        data: data + '&form_token=' + token,
                        url: url
                    }).done(function(data){
                        var json = jQuery.parseJSON(data);
                        if(json.status == 'success'){
                            console.log('success');
                            jQuery("#sendForm").attr("disabled", true);
                            jQuery(".form-response").prepend(json.message).show();
                        }else if(json.status == 'error'){
                            jQuery(".form-response").find('.alert').remove();
                            jQuery(".form-response").prepend(json.message);
                        }
        
                        gtag('event', action, {
                            'event_category': category
                            ,'event_label': label
                            // ,'value': value
                            // ,'event_callback': function() {}
                        });
        
                    }).always(function(){
                        //Apidae_CartModal.closeShowingCart();
                        loadData = false;
                    });
                });;
            });
        
        //}

    });
}

(function($) {

    //https://codepen.io/gjk/pen/BpyYoj
    jQuery('.single-owl').owlCarousel({
        items: 1,
        autoplay: true,
        loop: true,
        margin: 0,
        nav: false,
        dots: false,
        lazyLoad: true,
        animatein: 'fadeOut',
        animateOut: 'fadeOut',
        pagination: false,
        onInitialized: startProgressBar,
        onTranslate: resetProgressBar,
        onTranslated: startProgressBar
    });

    function fixOwlCurrentIdx(event) {
        let current = (event.item.index + 1) - event.relatedTarget._clones.length / 2;
        let itemsCount = event.item.count;

        if (current > itemsCount || current == 0) {
            current = itemsCount - (current % itemsCount);
        }

        return current - 1;
    }

    function startProgressBar(event) {
        var element = event.target; // DOM element, in this example .owl-carousel
        var items = event.item.count; // Number of items
        // var item = event.item.index; // Position of the current item
        var item = fixOwlCurrentIdx(event); // https://jsfiddle.net/yunusga/4zvpns6j/
        // console.log('item:' + item + ' items:' + items)

        var pourcent = 96 / items;
        var itemWidth = pourcent - 1;
        var itemLeft = (item * pourcent) + 2.5;

        if (item + items == items) {
            jQuery('.slide-progress').removeClass('active');
        }

        // apply keyframe animation
        jQuery(".current-slide-progress").css({
            left: itemLeft + "%",
            width: itemWidth + "%",
            transition: "width 5000ms"
        });
    }

    function resetProgressBar(event) {
        jQuery(".current-slide-progress").css({
            width: 0,
            transition: "width 0s"
        });
        var item = fixOwlCurrentIdx(event) - 1;
        jQuery('.slides-progress').children().eq(item).addClass('active');
    }


    jQuery('#slider-dispo').owlCarousel({
        margin: 30,
        nav: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            800: {
                items: 3
            },
            1000: {
                items: 4
            }
        }
    });

    if (jQuery('[colorify]').length) {
        jQuery('[colorify]').imagesLoaded(function() {
            colorify({
                id: 1,
                container: 'colorify',
                padding: 10,
                accuracy: 20,
                alpha: 1,
                gradient: true,
                gradientDirection: 'to right',
                give: {
                    property: 'background-color',
                    target: '.titleSup, .breadcrumbs'
                }
            });
            colorify({
                id: 1,
                container: 'colorify',
                padding: 10,
                accuracy: 20,
                alpha: 1,
                gradient: false,
                gradientDirection: 'to bottom right',
                give: {
                    property: 'color',
                    target: '.breadcrumbs'
                }
            });

            colorify({
                id: 1,
                container: 'colorify',
                padding: 10,
                accuracy: 20,
                alpha: 1,
                gradient: false,
                gradientDirection: 'to top left',
                give: {
                    property: 'color',
                    target: '.validiteSejour'
                }
            });

            colorify({
                id: 1,
                container: 'colorify',
                padding: 10,
                accuracy: 20,
                alpha: 1,
                gradient: false,
                gradientDirection: 'to bottom right',
                give: {
                    property: 'color',
                    target: 'fieldset legend'
                }
            });

            colorify({
                id: 1,
                container: 'colorify',
                padding: 10,
                accuracy: 20,
                alpha: .65,
                gradient: true,
                gradientDirection: 'to bottom left',
                give: {
                    property: 'background-image',
                    target: '.Presta-cover .main-headline .border'
                }
            });
        });
    }

    var picker = new Pikaday({
        field: document.getElementById('booking-datepicker'),
        firstDay: 1,
        format: 'DD/MM/YYYY',
        i18n: {
            previousMonth: 'Previous Month',
            nextMonth: 'Next Month',
            months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
            weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
            weekdaysShort: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
        },
        onSelect: function() {
            // self.search();
        }
    });

    // //map
    // if(jQuery('#mapPresta').length) {
    //
    //     var mapContainer = jQuery('#mapPresta');
    //     var latitude = mapContainer.siblings('meta[itemprop="latitude"]').attr('content');
    //     var longitude = mapContainer.siblings('meta[itemprop="longitude"]').attr('content');
    //
    //     if($.isNumeric(latitude) && $.isNumeric(longitude))
    //         google.maps.event.addDomListener(window, 'load', initPrestaMap(latitude,longitude));
    // }
    //
    // // Load the Visualization API and the columnchart package.
    // //google.load('visualization', '1', {packages: ['columnchart']});
    // google.load('visualization', '1', {packages: ['corechart']});
    //
    // function initPrestaMap(latitude,longitude) {
    //
    //     var map = new google.maps.Map(document.getElementById('mapPresta'), {
    //         zoom: 18,
    //         center: new google.maps.LatLng(latitude, longitude),
    //         mapTypeId: google.maps.MapTypeId.SATELLITE, //ROADMAP
    //         scrollwheel: false
    //     });
    //
    //     var image = apidae.base_url + apidae.theme_url + '/img/mapIcon/mapIconOn.png';
    //     var marker = new google.maps.Marker({
    //         position: new google.maps.LatLng(latitude, longitude),
    //         map: map,
    //         icon: image
    //     });
    //
    //     // Map Trace
    //     if(jQuery('#mapTrace').length){
    //         var $this = jQuery('#mapTrace');
    //         var url = $this.data("trace");
    //
    //         jQuery.ajax({
    //             type: "POST",
    //             url: apidae.base_url + '/XmlToJson.php',
    //             data: 'url=' + url,
    //             dataType: "json",
    //             success: function(data) {
    //                 ///////////////////
    //                 //trace
    //                 ///////////////////
    //                 /*var points = [];
    //                 var bounds = new google.maps.LatLngBounds ();
    //                 jQuery.each(data.trk.trkseg.trkpt, function() {
    //                     //console.log(this['@attributes'].lat);
    //                     var lat = this['@attributes'].lat;
    //                     var lon = this['@attributes'].lon;
    //                     var p = new google.maps.LatLng(lat, lon);
    //                     points.push(p);
    //                     bounds.extend(p);
    //                 });
    //
    //                 var poly = new google.maps.Polyline({
    //                     path: points,
    //                     strokeColor: "#FF00AA",
    //                     strokeOpacity: .7,
    //                     strokeWeight: 4
    //                 });
    //
    //                 poly.setMap(map);
    //
    //                 // zoom de la map en fonction des limites
    //                 map.fitBounds(bounds);*/
    //
    //                 ///////////////////
    //                 //trace + elevation
    //                 ///////////////////
    //                 map.setMapTypeId(google.maps.MapTypeId.TERRAIN);
    //                 var path = [];
    //                 var bounds = new google.maps.LatLngBounds ();
    //                 jQuery.each(data.trk.trkseg.trkpt, function() {
    //                     var p = new google.maps.LatLng(this['@attributes'].lat, this['@attributes'].lon);
    //                     path.push(p);
    //                     bounds.extend(p);
    //                 });
    //
    //                 // Create an ElevationService.
    //                 var elevator = new google.maps.ElevationService;
    //
    //                 // Draw the path, using the Visualization API and the Elevation service.
    //                 displayPathElevation(path, elevator, map);
    //
    //                 // zoom de la map en fonction des limites
    //                 map.fitBounds(bounds);
    //             }
    //         });
    //     }
    // }
    //
    // function displayPathElevation(path, elevator, map) {
    //     // Display a polyline of the elevation path.
    //     new google.maps.Polyline({
    //         path: path,
    //         strokeColor: '#E91E63',
    //         opacity: 1.0,
    //         map: map
    //     });
    //
    //     // Create a PathElevationRequest object using this array.
    //     // Ask for 256 samples along that path.
    //     // Initiate the path request.
    //     elevator.getElevationAlongPath({
    //         'path': path,
    //         'samples': 512
    //     }, plotElevation);
    // }
    //
    // // Takes an array of ElevationResult objects, draws the path on the map
    // // and plots the elevation profile on a Visualization API ColumnChart.
    // function plotElevation(elevations, status) {
    //     var chartDiv = document.getElementById('elevationChart');
    //     if (status !== google.maps.ElevationStatus.OK) {
    //         // Show the error code inside the chartDiv.
    //         chartDiv.innerHTML = 'Cannot show elevation: request failed because ' +
    //             status;
    //         return;
    //     }
    //     // Create a new chart in the elevation_chart DIV.
    //     var chart = new google.visualization.ColumnChart(chartDiv);
    //
    //     // Extract the data from which to populate the chart.
    //     // Because the samples are equidistant, the 'Sample'
    //     // column here does double duty as distance along the
    //     // X axis.
    //     var data = new google.visualization.DataTable();
    //     data.addColumn('string', 'Sample');
    //     data.addColumn('number', 'Elevation');
    //     for (var i = 0; i < elevations.length; i++) {
    //         data.addRow(['', elevations[i].elevation]);
    //     }
    //
    //     // Draw the chart using the data within its DIV.
    //     chart.draw(data, {
    //         height: 200,
    //         legend: 'none',
    //         titleY: 'Dénivelé (m)',
    //         colors: ['#CCCCCC'],
    //         bar: {groupWidth: "100%"}
    //     });
    // }

})(jQuery);